module.exports = __webpack_public_path__ + "img/root010.09a41ef6.png";